import './cateringbellinis/style';
import FormStructure from './cateringbellinis/form_structure';

export default FormStructure;